import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import {getBookingRouteUrl} from "@services/booking-route-service";
import { RouteNames } from "@services/booking-route-service";
import {getTranslations} from "@shared/Services/translations";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginLink',
  setup(__props) {

const translations = getTranslations();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _unref(getBookingRouteUrl)(_unref(RouteNames).Login),
    class: "login-link"
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "icon icon--captain login-link__icon" }, null, -1 /* CACHED */)),
    _createTextVNode(_toDisplayString(_unref(translations)['bookings.header.login']), 1 /* TEXT */)
  ], 8 /* PROPS */, _hoisted_1))
}
}

})